import React from 'react';
import { useLocalize } from '@core-ui/localization-provider';
import { Interpolation, Theme } from '@core-ui/react-stitch/types';
import { QuickAddIcon } from '../quick-add-icon';
import { OPEN_BUTTON_ARIA_LABEL } from '../../localization-tokens';

const getStrokeColor =  (theme: Theme): string => {
  const color = theme.brand === 'at' ? theme.color.g2 : theme.color.b2;
  return color;
};

const buttonStyles = (theme: Theme): Interpolation<Theme> => ({
  outline: 'none',
  border: 'none',
  position: 'absolute',
  padding: '0',
  height: '45px',
  width: '45px',
  bottom: '0.75rem',
  right: '0.75rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'transparent',
  cursor: 'pointer',
  '&:hover,&:focus': {
    '& circle:first-of-type': {
      stroke: getStrokeColor(theme),
      fill: '#F5F5F5',
      opacity: '1',
      strokeWidth: '1.5px'
    }
  }
});

type ToggleButtonProps = {
  toggleOpen: () => void;
  sendTealiumMetrics: () => void;
};

const ToggleButton = (props: ToggleButtonProps): JSX.Element => {
  const { toggleOpen, sendTealiumMetrics } = props;

  const { localize } = useLocalize();
  return (
    <button
      aria-label={localize(OPEN_BUTTON_ARIA_LABEL)}
      className="cat_quick-add__toggle-button"
      css={buttonStyles}
      onClick={e => {
        e.preventDefault();
        toggleOpen();
        sendTealiumMetrics();
      }}
      type="button"
    >
      <QuickAddIcon />
    </button>
  );
};

export default ToggleButton;
